// extracted by mini-css-extract-plugin
export default {"_wrap":"Fade__wrap__AOQF6","invisible":"Fade_invisible__wXP9V Fade__wrap__AOQF6","visible":"Fade_visible__aX6gr Fade__wrap__AOQF6"};